<input
    type="text"
    class="form-control"
    #datePicker
    bsDatepicker
    [placeholder]="placeholder()"
    [bsValue]="lastDate"
    (bsValueChange)="setDate($event)"
    [bsConfig]="bsConfig()" />
